<div class="alert alert-info" ng-show="vm.ready === 'loading'">
    <i class="fa fa-spinner fa-spin"></i> Medikation wird geladen ...
</div>

<h4>Medikament verordnen</h4>
<form class="form-vertical" name="newdrugform" id="newdrugform">
<!-- Suchbox, Medikamentendaten -->
    <div class="row form-group">
        <!-- Medikamentensuchbox-->
        <div class="col-xs-12 col-md-6">
            <label for="newdrugname">Medikament <span uib-tooltip="Plichtfeld">*</span> <sprhelp tip="Medikamentensuche" descref="vm.sprsearch"></sprhelp>  </label>
            <div class="input-group">
                <input type="text" class="form-control" placeholder="Medikament oder PharmaNr."
                       ng-model="vm.newdrug.name"
                       ng-required="!vm.newdrug.name"
                       autocomplete="noway"
                       ng-class="{ 'has-error': newdrugform.$invalid }"
                       typeahead-on-select="vm.showdruginfo($item)"
                       typeahead-min-length="3"
                       uib-typeahead="drug as drug.text for drug in vm.getDrugs($viewValue)"
                       typeahead-loading="loadingNames"
                       id="newdrugname"
                       select-first-match="false"
                       typeahead-no-results="vm.noResults">
                <span class="input-group-btn">
                    <button class="btn btn-info" type="button"><i class="fa fa-search"></i></button>
                </span>
            </div>
            <i ng-show="loadingNames" class="fa fa-refresh"></i>

            <div ng-show="vm.noResults" style="color: #cc3333; font-weight: bold">
                <i class="fa fa-warning"></i> Keine Medikamente gefunden!
            </div>
        </div>
        <!-- SV Box, FI, Alternativen -->
        <div class="col-xs-12 col-md-6">
            <label for="fooname">Detailinformationen, Alternativen</label>
            <div style="display: block" class="druginfo">
                <!-- Platzhalter -->
                <span ng-hide="vm.newdrug.name"><i class="btn btn-info fa fa-warning"></i> W&auml;hlen Sie zuerst ein Medikament aus</span>
                <!-- Button SV Box -->
                <span class="btn btn-success" ng-show="vm.newdrug.box === 'G'"
                      uib-tooltip="SV Green Box">G</span>
                <span class="btn btn-warning" ng-show="vm.newdrug.box === 'Y'"
                      uib-tooltip="SV Yellow Box">Y</span>
                <span class="btn btn-danger" ng-show="vm.newdrug.box === 'NB'" uib-tooltip="SV No Box">NB</span>

                <!-- Fachinformationen -->
                <a class="btn btn-info"
                   href="/routes{{vm.newdrug.fi}}" target="_blank"
                   ng-show="vm.newdrug.fi"
                   uib-tooltip="Fachinformationen">FI PDF</a>

                <!-- Button Restriktionen, Ind -->
                <span class="btn btn-danger" ng-show="vm.newdrug.re"
                      uib-tooltip="Restriktionen" ng-bind="vm.newdrug.re"
                      uib-popover-template="vm.repopovertpl" popover-title="Restriktionen"
                      popover-placement="auto bottom" popover-trigger="outsideClick"></span>
                <span class="btn btn-primary" ng-show="vm.newdrug.ind"
                      uib-tooltip="Indikationen" popover-trigger="outsideClick"
                      uib-popover-template="vm.indpopovertpl" popover-title="Indikationen"
                      popover-placement="auto bottom">IND</span>
                <span class="btn btn-info" ng-show="vm.newdrug.hint"
                      uib-tooltip="Hinweis" popover-trigger="outsideClick"
                      uib-popover-template="vm.hintpopovertpl" popover-title="Hinweis"
                      popover-placement="auto bottom"><i
                    class="fa fa-info-circle"></i></span>
                <span class="btn btn-warning" ng-show="vm.newdrug.kz"
                      uib-tooltip="Kassenzeichen"
                      uib-popover-template="vm.kzpopover" popover-title="Hinweis" popover-placement="auto bottom"
                      ng-bind="vm.newdrug.kz"></span>

                <!-- Button Langzeitbewilligung -->
                <span class="btn btn-info" ng-show="vm.newdrug.permpermit"
                      uib-tooltip="Langzeitbewilligung" ng-bind="vm.newdrug.permpermit"
                      uib-popover-template="vm.pppopovertpl" popover-title="Langzeitbewilligung"
                      popover-placement="auto bottom" popover-trigger="outsideClick"></span>

                <!-- Alternativen -->
                <span class="btn btn-{{vm.newdrug.alttype}}" ng-show="vm.newdrug.alternatives.length > 0"
                      uib-popover-template="vm.drugalternativestpl" popover-title="Alternativen"
                      popover-placement="auto bottom" popover-trigger="outsideClick"
                      uib-tooltip="{{vm.newdrug.alttypetext}}">Alternativen</span>

                <!-- SV ATC Alternativen -->
                <span class="btn btn-warning" ng-show="vm.newdrug.atcalternatives.length > 0"
                      uib-popover-template="vm.atcalternativestpl"
                      popover-title="SV erstattete Alternativen laut ATC Code"
                      popover-placement="auto bottom" popover-trigger="outsideClick"
                      uib-tooltip="SV erstattete Alternativen laut ATC Code">SV Alternativen lt. ATC Code</span>
            </div>
        </div>
    </div>
    <!-- Einahme/Signatur, PkgSize, OP, Dauermed/permanent -->
    <div class="row  form-group">
        <div class="col-xs-12 col-md-3">
            <!-- Einnahmeanweisung -->
            <div class="form-group">
                <label for="newdrugamount">Einnahme <span uib-tooltip="Plichtfeld">*</span> <sprhelp tip="Ausw&auml;hlen oder eingeben" descref="vm.sprsignature"></sprhelp>  </label>
                <div class="input-group">
                    <input class="form-control" ng-model="vm.newdrug.amount" id="newdrugamount"
                           autocomplete="noway" autocorrect="off" autocapitalize="off" spellcheck="false"
                           placeholder="1-0-1-0" ng-required="!vm.newdrug.amount"
                           ng-class="{ 'has-error': newdrugform.$invalid }">
                    <div class="input-group-btn" uib-dropdown>
                        <button type="button" class="btn btn-default" uib-dropdown-toggle><span class="caret"></span>
                        </button>
                        <ul id="amountmenu" class="dropdown-menu dropdown-menu-right" role="menu" uib-dropdown-menu
                            ng-hide="vm.conf.drugsignature.length">
                            <li ng-click="vm.newdrug.amount='1-0-0'">1-0-0</li>
                            <li ng-click="vm.newdrug.amount='1-0-1'">1-0-1</li>
                            <li ng-click="vm.newdrug.amount='0-1-0'">0-1-0</li>
                            <li ng-click="vm.newdrug.amount='0-0-1'">0-0-1</li>
                            <li ng-click="vm.newdrug.amount='1-1-1'">1-1-1</li>
                            <li ng-click="vm.newdrug.amount='0-0-0-1'">0-0-0-1</li>
                        </ul>
                        <ul id="amountmenu2" class="dropdown-menu dropdown-menu-right" role="menu" uib-dropdown-menu
                            ng-show="vm.conf.drugsignature.length">
                            <li ng-repeat="sig in vm.conf.drugsignature" ng-click="vm.newdrug.amount=sig">{{sig}}</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-xs-12 col-md-3">
            <!--Packungsgroesse-->
            <label for="newdrugpkgsize">Packungsgröße <sprhelp tip="Packungsgr&ouml;&szlig;e" descref="vm.sprpkgsize"></sprhelp></label>
            <input class="form-control" ng-model="vm.newdrug.pkgsize" id="newdrugpkgsize"
                   placeholder="30 Stk">
        </div>
        <div class="col-xs-12 col-md-3">
            <label for="newdrugamount">Packungsanzahl <span uib-tooltip="Plichtfeld">*</span> <sprhelp tip="Anzahl" descref="vm.sprpkgnr"></sprhelp></label>
            <!--OP-->
            <div class="radio" ng-init="vm.newdrug.op='OP I'">
                <label for="newdrugop1" class="radio-inline">
                    <input type="radio" value="OP I" required
                           ng-model="vm.newdrug.op"
                           id="newdrugop1">OP I</label>
                <label for="newdrugop2" class="radio-inline">
                    <input type="radio" value="OP II"
                           ng-model="vm.newdrug.op"
                           id="newdrugop2">OP II</label>
                <label for="newdrugop3" class="radio-inline">
                    <input type="radio" value="OP III"
                           ng-model="vm.newdrug.op"
                           id="newdrugop3">OP III</label>
            </div>
        </div>
        <div class="col-xs-12 col-md-3">
            <!--Dauermedikation-->
            <label for="newdrugamount">Einnahmedauer <sprhelp tip="Dauermedikation vs. Anla&szlig;medikation" descref="vm.sprduration"></sprhelp></label>
            <div class="input-group">
                <div class="checkbox">
                    <label for="newdrugperm" class="checkbox-inline">
                        <input type="checkbox"
                               ng-model="vm.newdrug.permanent"
                               id="newdrugperm">Dauermedikamentation
                    </label><br>
                </div>
            </div>
        </div>
    </div>
    <!-- Rezeptvermerk, IND, nocEx-->
    <div class="row form-group">
        <div class="col-xs-12 col-md-6">
            <!--Rezeptvermerk-->
            <div class="row">
                <div class="col-xs-12">
                    <div class="form-group">
                        <label for="newdrugcomment">Rezeptvermerk <sprhelp tip="Rezeptvermerk" descref="vm.sprcomment"></sprhelp></label>
                        <textarea class="form-control" ng-model="vm.newdrug.comment" id="newdrugcomment"
                                  placeholder=""></textarea>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-xs-12 col-md-6">
            <div class="input-group">
                <strong>Spezifika <sprhelp tip="Indikationen" descref="vm.sprind"></sprhelp></strong>

                <!--IND-->
                <div class="checkbox">
                    <label for="newdrugind" class="checkbox-inline">
                        <input type="checkbox"
                               ng-model="vm.newdrug.ind"
                               id="newdrugind">IND (Indikation)
                        <!-- <span ng-show="vm.newdrug.indcriteria" uib-tooltip="Indikationen"
                               uib-popover-template="vm.indpopovertpl"
                               popover-title="Indikationen" popover-placement="auto bottom"><i class="fa fa-info-circle btn btn-primary"></i></span> -->
                    </label><br>
                    <label for="newdrugexpnoct" class="checkbox-inline">
                        <input type="checkbox"
                               ng-model="vm.newdrug.expnoc"
                               id="newdrugexpnoct">Exp. Noct. (Nachtausgabe)
                    </label><br>
                </div>

            </div>
        </div>
    </div>

    <!-- Verschreiben Button -->
    <div class="row form-group">
        <div class="col-xs-12">
            <button class="btn btn-success spacer-top" type="button"
                    ng-disabled="!newdrugform.$valid"
                    ng-click="vm.addDrug()">
                <span ng-show="vm.drug_saved"><i class="fa fa-check" ></i>&nbsp;Medikament verordnet</span>
                <span ng-hide="vm.drug_saved">Medikament verordnen</span>
            </button>
        </div>
    </div>
</form>

<hr>



<!-- Hinweis Pop-Over -->
<script type="text/ng-template" id="hintpopovertpl.html">
    <div ng-bind-html="vm.newdrug.hint"></div>
</script>

<!-- Indikation Pop-Over -->
<script type="text/ng-template" id="indpopovertpl.html">
    <div ng-bind-html="vm.newdrug.indcriteria"></div>
</script>

<!-- Restriktion Pop-Over -->
<script type="text/ng-template" id="repopovertpl.html">
    <div ng-bind-html="vm.newdrug.recriteria"></div></script>

<!-- Langzeitbewilligung Pop-Over -->
<script type="text/ng-template" id="pppopovertpl.html">
    <div>
        <p>Dieses Arzneimittel ist langzeitbewilligungsf&auml;hig. Die Zahl gibt die Anzahl an Monaten an:
            <span ng-bind="vm.newdrug.permpermit"></span>
        </p>
        <p ng-bind-html="vm.newdrug.recriteria"></p>
    </div>
</script>

<!-- Kassenzeichen Pop-Over-->
<script type="text/ng-template" id="kzpopover.html">
    <div>
        <h3>Allgemeine Kassenzeichen</h3>
        <div class="row">
            <div class="col-xs-1">F2J</div>
            <div class="col-xs-11">Die Arzneispezialität ist nur für die Behandlung von Kindern bis zum vollendeten 2.
                Lebensjahr in den Grünen Bereich des Erstattungskodex aufgenommen. Für Verordnungen außerhalb der angegebenen
                Altersbeschränkung ist die Arzneispezialität wie eine Arzneispezialität des Gelben Bereichs des Erstattungskodex
                zu behandeln, wobei, wenn die Notwendigkeit für die Verordnung einer kleinkindergerechten Therapie oder Dosierung
                entsprechend den Bestimmungen der Heilmittel-Bewilligungs- und Kontroll-Verordnung und den Richtlinien über die
                ökonomische Verschreibweise dokumentiert wird, die vorherige ärztliche Bewilligung des chef- und
                kontrollärztlichen Dienstes durch eine nachfolgende Kontrolle der Einhaltung der bestimmten Verwendung ersetzt
                werden kann.
            </div>
        </div>
        <div class="row">
            <div class="col-xs-1">F6J</div>
            <div class="col-xs-11">Die Arzneispezialität ist nur für die Behandlung von Kindern bis zum vollendeten 6.
                Lebensjahr in den Grünen Bereich des Erstattungskodex aufgenommen. Für Verordnungen außerhalb der angegebenen
                Altersbeschränkung ist die Arzneispezialität wie eine Arzneispezialität des Gelben Bereichs des Erstattungskodex
                zu behandeln, wobei, wenn die Notwendigkeit für die Verordnung einer kindergerechten Therapie oder Dosierung
                entsprechend den Bestimmungen der Heilmittel-Bewilligungs- und Kontroll-Verordnung und den Richtlinien über die
                ökonomische Verschreibweise dokumentiert wird, die vorherige ärztliche Bewilligung des chef- und
                kontrollärztlichen Dienstes durch eine nachfolgende Kontrolle der Einhaltung der bestimmten Verwendung ersetzt
                werden kann.
            </div>
        </div>
        <div class="row">
            <div class="col-xs-1">F14</div>
            <div class="col-xs-11">Die Arzneispezialität ist nur für die Behandlung von Kindern und Jugendlichen bis zum
                vollendeten 14. Lebensjahr in den Grünen Bereich des Erstattungskodex aufgenommen. Für Verordnungen außerhalb der
                angegebenen Altersbeschränkung ist die Arzneispezialität wie eine Arzneispezialität des Gelben Bereichs des
                Erstattungskodex zu behandeln, wobei, wenn die Notwendigkeit für die Verordnung einer kindergerechten Zubereitung
                (z.B.: Saft) oder Dosierung entsprechend den Bestimmungen der Heilmittel-Bewilligungs- und Kontroll-Verordnung und
                den Richtlinien über die ökonomische Verschreibweise dokumentiert wird, die vorherige ärztliche Bewilligung des
                chef- und kontrollärztlichen Dienstes durch eine nachfolgende Kontrolle der Einhaltung der bestimmten Verwendung
                ersetzt werden kann.
            </div>
        </div>
        <div class="row">
            <div class="col-xs-1">DSX</div>
            <div class="col-xs-11">(steht für die Facharztkennzeichen A, D, K, L): Desensibilisierungsprodukt; frei
                verschreibbar durch Facharzt/Fachärztin für Lungenkrankheiten, Haut- und Geschlechtskrankheiten, Kinderheilkunde
                und Hals-, Nasen- und Ohrenkrankheiten.
            </div>
        </div>
        <h3>Kassenzeichen Facharztkennung</h3>
        <div class="row">
            <div class="col-xs-1"></div>
            <div class="col-xs-11"></div>
        </div>
        <div class="row">
            <div class="col-xs-1">A</div>
            <div class="col-xs-11">Facharzt/Fachärztin für Lungenkrankheiten</div>
        </div>
        <div class="row">
            <div class="col-xs-1">Au</div>
            <div class="col-xs-11">Facharzt/Fachärztin für Augenkrankheiten</div>
        </div>
        <div class="row">
            <div class="col-xs-1">D</div>
            <div class="col-xs-11">Facharzt/Fachärztin für Haut- und Geschlechtskrankheiten</div>
        </div>
        <div class="row">
            <div class="col-xs-1">F</div>
            <div class="col-xs-11">Facharzt/Fachärztin für Frauenheilkunde und Geburtshilfe</div>
        </div>
        <div class="row">
            <div class="col-xs-1">K</div>
            <div class="col-xs-11">Facharzt/Fachärztin für Kinderheilkunde</div>
        </div>
        <div class="row">
            <div class="col-xs-1">L</div>
            <div class="col-xs-11">Facharzt/Fachärztin für Hals-, Nasen- und Ohrenkrankheiten</div>
        </div>
        <div class="row">
            <div class="col-xs-1">P</div>
            <div class="col-xs-11">Facharzt/Fachärztin für Psychiatrie oder Psychiatrie und Neurologie oder Neurologie und
                Psychiatrie oder Kinder- und Jugendpsychiatrie
            </div>
        </div>

        <div class="row">
            <div class="col-xs-1">R</div>
            <div class="col-xs-11">Facharzt/Fachärztin für Radiologie
            </div>
        </div>

        <div class="row">
            <div class="col-xs-1">U</div>
            <div class="col-xs-11">Facharzt/Fachärztin für Urologie</div>
        </div>


    </div>
</script>

<!-- Alternativen Pop-Over -->
<script type="text/ng-template" id="drugalternativestpl.html">
    <div style="padding: 20px"><!-- template must be enclosed by single tag -->
        <div style="padding: 20px"><!-- template must be enclosed by single tag -->
            <div class="row" style="margin-bottom: 2px" ng-repeat="alt in vm.newdrug.alternatives">
                <div class="btn btn-{{alt.color}} col-xs-12"
                     uib-tooltip="{{alt.tooltip}}"
                     ng-click="vm.replaceDrug(alt)"
                     ng-bind="alt.name">
                </div>
            </div>
            <div class="alert alert-danger"><h3><i class="fa fa-warning"></i> Wichtiger Hinweis!</h3>
                <p>
                    Die hier gelisteten Medikamente wurden auf Basis des EKO Tools der SV ausgewählt. Sie sind nach Preis sortiert -
                    das günstigste zuerst. Es können echte Generika (gleicher Wirkstoff, gleiche Stärke), Alternativen mit
                    geringfügig anderer Wirkstoffkonzentration, oder Biosimilars (änhlicher Wirksstoff) aufgelistet sein.
                    Farbcodierung/Hinweise der jeweiligen Alternative beachten!</p>

                <p>Prüfung der Alternativen auf ihre Einsatzmöglichkeit und ggf. Auswahl eines Ersatzpräparats obliegt
                    AUSSCHLIESSLICH der berhandelnden Ärztin / dem behandelndem Arzt!</p>
            </div>
        </div>
    </div>
</script>

<!-- ATC Wirkstoff Alternativen Pop-Over -->
<script type="text/ng-template" id="atcalternativestpl.html">
    <div style="padding: 20px"><!-- template must be enclosed by single tag -->
        <div class="alert alert-danger"><h3><i class="fa fa-warning"></i> Wichtiger Hinweis!</h3>
            <p>
                Die hier gelisteten Medikamente wurden auf Basis des ATC Codes ausgewählt. Wenn das ursprüngliche - nicht mehr
                erstattungsfähige - Präparat mehrere Wirkstoffe beinhaltet hat, werden auch Arzneien die nur einen der Wirkstoffe
                beinhalten angezeigt. Die Alternativen varieren in der Stärke des Wirkstoffes. </p>

            <p>Prüfung der Alternativen auf ihre Einsatzmöglichkeit und ggf. Auswahl eines Ersatzpräparats obliegt AUSSCHLIESSLICH der berhandelnden Ärztin
                / dem behandelndem Arzt!</p>

            <!-- <p>
             <div class="btn btn-danger" ng-click="atcaltshow = true" ng-hide="atcaltshow">Habe ich verstanden, Alternativen jetzt anzeigen</div>
             </p>-->
        </div>

        <!--<div ng-show="atcaltshow">-->
        <div>
            <div class="row" style="margin-bottom: 2px" ng-repeat="alt in vm.newdrug.atcalternatives">
                <div ng-show="alt.box === 'G'" class="btn btn-success col-xs-12"
                     uib-tooltip="SV Green Box Alternative"
                     ng-click="vm.replaceDrug(alt)"
                     ng-bind="alt.name">
                </div>
                <div ng-show="alt.box === 'Y'" class="btn btn-warning col-xs-12"
                     uib-tooltip="SV Yellow Box Alternative"
                     ng-click="vm.replaceDrug(alt)"
                     ng-bind="alt.name">
                </div>
                <div ng-hide="alt.box" class="btn btn-danger col-xs-12"
                     uib-tooltip="Nicht erstattungsfähige Alternative"
                     ng-click="vm.replaceDrug(alt)"
                     ng-bind="alt.ZBEZ">
                </div>
            </div>


        </div>

    </div>


    <div class="row" style="margin-bottom: 2px" ng-repeat="alt in vm.newdrug.alternatives">
        <div class="btn btn-{{alt.color}} col-xs-12"
             uib-tooltip="{{alt.tooltip}}"
             ng-click="vm.replaceDrug(alt)"
             ng-bind="alt.name">
        </div>
        <!--<div class="col-xs-9" ng-bind="alt.name"></div>
        <div class="col-xs-3">
          <button class="btn btn-{{alt.color}}" uib-tooltip="{{alt.tooltip}}" ng-click="replaceDrug(alt)">
            Auswählen
          </button>
        </div>-->
    </div>
    </div>
</script>